import React from "react";
import ServiceBanner from "../Components/ServicesPageComponents/ServiceBanner";
import ServicesSummary from "../Components/ServicesPageComponents/ServicesSummary";
import { Helmet } from "react-helmet";

const Services = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Diamond Certification & Testing Services | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Explore our expert services, including diamond certification and testing, diamond sealing service, diamond online service, and diamond hologram stickers."
        />
        <meta
          name="keywords"
          content="Services, lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Diamond Certification & Testing Services | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Explore our expert services, including diamond certification and testing, diamond sealing service, diamond online service, and diamond hologram stickers."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/services"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Diamond Certification & Testing Services | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Explore our expert services, including diamond certification and testing, diamond sealing service, diamond online service, and diamond hologram stickers."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/services"
        />{" "}
      </Helmet>
      <div>
        <ServiceBanner />
        <ServicesSummary />
      </div>
    </>
  );
};

export default Services;
